import type { Translations } from "./en";
import { useCasesFr } from "./use-cases.fr";

export const fr: Translations = {
	locale: "fr",
	seo: {
		blogTitle: "Blog",
		pages: {
			home: {
				name: "Accueil",
				title: "Applications web, mobiles et logiciels métier",
				description:
					"Lezo développe et maintient des applications web et mobiles avec un développement assisté par IA et encadré : logiciels métier sur mesure environ 5 fois moins chers, migration React Native vers Expo.",
			},
			businessApps: {
				name: "Applications métier",
				title: "Applications métier sur mesure",
				description:
					"Un logiciel métier sur mesure, développé avec l’IA sous le contrôle d’un développeur : environ 5 fois moins cher qu’un développement classique, pour un budget comparable à un abonnement SaaS.",
			},
			expoMigration: {
				name: "Migration Expo",
				title: "Migration React Native vers Expo",
				description:
					"Diagnostic, plan, migration et transmission : Lezo migre votre application React Native vers Expo et divise par 4 environ le coût de sa maintenance et de ses nouvelles fonctionnalités.",
			},
			useCases: {
				name: "Cas d’usage",
				title: "Cas d’usage : des logiciels sur mesure par métier",
				description:
					"Maintenance CVC, cabinets QHSE, entreprises de propreté, reprise d’application React Native : la journée type, ce que le métier exige et l’outil que Lezo construirait pour chaque situation.",
			},
			useCaseHvac: {
				name: "Maintenance CVC",
				title: "Logiciel de maintenance CVC pour vos contrats d’entretien",
				description:
					"Logiciel de maintenance CVC sur mesure : planning issu des contrats, relevés en chaufferie hors réseau, attestations d’entretien générées sur place et portail pour les syndics, sans licence par technicien.",
			},
			useCaseQhse: {
				name: "Cabinet QHSE",
				title:
					"Logiciel d’audit et de suivi des plans d’action pour cabinet QHSE",
				description:
					"Outil d’audit sur mesure pour cabinet QHSE : constats saisis sur site, cotation selon votre méthode, rapports à votre marque et portail client pour suivre les plans d’action, vendu comme un service.",
			},
			useCaseCleaning: {
				name: "Propreté",
				title: "Logiciel de contrôle qualité pour entreprise de propreté",
				description:
					"Logiciel de contrôle qualité propreté sur mesure : grilles par contrat, score calculé sur place, non-conformités suivies jusqu’à leur levée et portail client qui construit votre dossier de renouvellement.",
			},
			useCaseTakeover: {
				name: "Reprise d’app React Native",
				title:
					"Reprendre une application React Native abandonnée par son prestataire",
				description:
					"Votre application React Native a été livrée par une agence partie ? Lezo récupère vos accès, diagnostique l’application et la remet en conformité avec Google Play et l’App Store sur Expo, sans tout réécrire.",
			},
			work: {
				name: "Réalisations",
				title: "Réalisations",
				description:
					"Les projets construits et exploités par Lezo : le besoin, la solution, ce que Lezo a fait exactement et comment le logiciel est utilisé.",
			},
			questoveryCase: {
				name: "Questovery",
				title: "Questovery, plateforme web et mobile éditée par Lezo",
				description:
					"Comment Lezo a conçu, développé et exploite Questovery : éditeur web, application mobile et suivi des expériences.",
			},
			vaerdictCase: {
				name: "Vaerdict",
				title: "Vaerdict, simulateur immobilier pour CGP développé par Lezo",
				description:
					"Comment Lezo a développé Vaerdict, le logiciel de simulation d’investissement immobilier des conseillers en gestion de patrimoine, et accompagné son déploiement et sa commercialisation.",
			},
			chouicCase: {
				name: "Chouic",
				title:
					"Chouic : 3 applications React Native migrées vers Expo en un mois",
				description:
					"Comment Lezo a migré trois applications mobiles du studio de jeux Chouic de React Native vers Expo en un mois, et transmis la méthode qui a permis à l’équipe d’en migrer une quatrième seule.",
			},
			products: {
				name: "Produits",
				title: "Produits",
				description:
					"Lezo édite ses propres logiciels, dont Questovery, la plateforme pour créer et faire vivre des jeux de piste et visites ludiques sur mobile.",
			},
			about: {
				name: "À propos",
				title: "À propos",
				description:
					"Lezo, entreprise de développement et d’édition de logiciels : activité, méthode de collaboration, engagements et présentation de son fondateur.",
			},
			contact: {
				name: "Contact",
				title: "Contact",
				description:
					"Décrivez votre application ou votre fonctionnement actuel. Lezo vous recontacte pour préciser le besoin et la prochaine étape.",
			},
		},
	},
	nav: {
		brand: "Lezo",
		home: "Accueil",
		blog: "Blog",
		docs: "Documents",
		services: "Services",
		businessApps: "Applications métier",
		businessAppsDescription:
			"Collecte terrain, rapports, suivi de dossiers et portail client.",
		expoMigration: "Migration Expo",
		expoMigrationDescription:
			"Migrer une application React Native existante vers Expo.",
		useCases: "Cas d’usage",
		useCasesAll: "Tous les cas d’usage",
		useCasesAllDescription: "Quatre métiers, de la journée type à l’outil.",
		work: "Réalisations",
		products: "Produits",
		about: "À propos",
		contact: "Parlons de votre projet",
		menu: "Menu",
		skip: "Aller au contenu",
		language: "Langue",
	},
	common: {
		exampleBadge: "Exemple d’usage",
		shotPending: "Capture réelle à intégrer",
		faqLabel: "Questions fréquentes",
		yourRole: "Votre rôle",
		illustrationBadge: "Illustration",
	},
	home: {
		hero: {
			label:
				"Développement assisté par IA · Web et mobile · Édition de logiciels",
			title: "Des applications pour mieux faire fonctionner votre activité.",
			emphasis: "fonctionner",
			intro:
				"Lezo conçoit vos logiciels métier et modernise vos applications web et mobiles, avec l’IA intégrée à chaque étape du développement. La même qualité pour une fraction du coût d’hier, et le même interlocuteur du cadrage à la maintenance.",
			primaryCta: "Parlons de votre projet",
			secondaryCta: "Découvrir les services",
			entriesLabel: "Deux portes d’entrée :",
			entries: {
				businessApps: "Applications métier sur mesure",
				expoMigration: "Migration React Native vers Expo",
			},
		},
		marquee: {
			label: "Ce que nous construisons et maintenons",
			items: {
				a: "Suivi des dossiers",
				b: "Collecte terrain",
				c: "Rapports",
				d: "Portail client",
				e: "Connexions avec vos outils",
				f: "Migration Expo",
				g: "iOS et Android",
				h: "Maintenance",
				i: "Évolutions",
				j: "Développement assisté par IA",
			},
		},
		services: {
			label: "Services",
			title: "Deux façons de travailler avec Lezo",
			description:
				"Vous voulez outiller votre activité ou moderniser une application mobile existante ? Chaque offre a son propre déroulement et ses livrables.",
			items: {
				businessApps: {
					eyebrow: "Applications métier",
					title: "Moins de ressaisies, un meilleur suivi de vos opérations.",
					description:
						"Suivi des dossiers, collecte terrain, rapports, portail client : Lezo construit votre logiciel métier, le relie à vos outils et le fait évoluer avec vous.",
					audience:
						"Pour les dirigeants et responsables des opérations de sociétés de services spécialisées.",
					points: {
						scoping: "Un cadrage avec vos utilisateurs",
						firstVersion: "Une première version centrée sur un usage",
						followUp: "Maintenance et évolutions après la livraison",
						cost: "Un coût environ 5 fois inférieur à un développement classique",
					},
					link: "Découvrir les applications métier",
				},
				expoMigration: {
					eyebrow: "Migration Expo",
					title: "Des builds et des publications plus simples à maîtriser.",
					description:
						"Lezo analyse votre application React Native, la migre vers Expo, vérifie les builds et passe le relais à votre équipe.",
					audience: "Pour les CTO, responsables techniques et leads mobile.",
					points: {
						diagnostic: "Un diagnostic de l’existant",
						plan: "Un plan de migration et sa validation",
						handover: "Documentation et passage de relais",
						cost: "Une maintenance environ 4 fois moins coûteuse",
					},
					link: "Découvrir la migration Expo",
				},
			},
		},
		ai: {
			label: "Développement assisté par IA",
			title: "Le même logiciel, environ 5 fois moins cher",
			description:
				"Un logiciel métier coûtait autour de 100 000 € à développer, puis 20 000 à 30 000 € par an pour le maintenir et le faire évoluer. Lezo intègre l’IA à chaque étape du développement, sous le contrôle d’un développeur expérimenté : la qualité reste la même, le coût est divisé par 5 environ.",
			saas: {
				title: "Votre propre logiciel plutôt qu’un abonnement ?",
				description:
					"À ce prix, faire développer un outil adapté à votre processus revient, sur quelques années, au coût d’un abonnement SaaS pensé pour tout le monde. Avec une différence : l’outil est fait pour vous, et il vous appartient.",
				link: "Comparer avec un abonnement",
			},
		},
		work: {
			label: "Réalisation",
			title: "Questovery, conçu, développé et exploité par Lezo",
			description:
				"Questovery permet aux professionnels qui accueillent du public de créer des jeux de piste et des visites ludiques, de les proposer à leurs visiteurs et d’en suivre l’usage.",
			facts: {
				role: {
					label: "Rôle de Lezo",
					value: "Conception, développement, mise en production et édition",
				},
				platforms: {
					label: "Plateformes",
					value: "Éditeur web, application mobile, suivi des expériences",
				},
				usage: {
					label: "Usage",
					value: "Visites tout au long de l’année et événements ponctuels",
				},
			},
			link: "Lire l’étude de cas",
		},
		process: {
			label: "Collaboration",
			title: "Une collaboration prévisible, étape par étape",
			description:
				"À tout moment, vous savez ce que nous faisons, ce que vous validez et ce qui vient ensuite.",
			steps: {
				understand: {
					title: "Comprendre",
					description:
						"Nous examinons le problème, les utilisateurs, l’existant et les contraintes.",
					client: "Vous partagez votre fonctionnement et vos priorités.",
				},
				scope: {
					title: "Cadrer",
					description:
						"Nous définissons une première mission : ses livrables, son calendrier et son prix.",
					client: "Vous validez le périmètre et la proposition.",
				},
				build: {
					title: "Réaliser",
					description:
						"Nous développons par étapes et vous montrons régulièrement l’avancement.",
					client: "Vous testez et arbitrez aux points de validation.",
				},
				evolve: {
					title: "Transmettre et faire évoluer",
					description:
						"Nous livrons, documentons et organisons l’exploitation, la maintenance et les évolutions.",
					client: "Vous choisissez le niveau de suivi et les évolutions.",
				},
			},
			note: "Un premier échange suffit pour savoir si un diagnostic ou un cadrage est utile. Si oui, vous en connaissez le contenu et le coût éventuel avant de commencer.",
		},
		company: {
			label: "L’entreprise",
			title: "Développer pour nos clients, éditer nos propres produits",
			description:
				"Lezo est une entreprise de développement et d’édition de logiciels. Nous concevons des applications web et mobiles adaptées au travail de nos clients, modernisons leurs applications existantes et éditons nos propres produits, dont Questovery.",
			pillars: {
				design: {
					title: "Concevoir",
					description:
						"Des applications web et mobiles construites autour de vos usages réels, pas d’un modèle générique.",
				},
				modernize: {
					title: "Moderniser",
					description:
						"Des applications existantes reprises, stabilisées et préparées pour leurs prochaines évolutions.",
				},
				publish: {
					title: "Éditer",
					description:
						"Des produits que nous exploitons nous-mêmes : la mise en production et la maintenance font partie de notre quotidien.",
				},
			},
			link: "En savoir plus sur Lezo",
		},
		products: {
			label: "Produits édités",
			title: "Questovery",
			description:
				"Créez et faites vivre vos jeux de piste, visites ludiques et expériences sur mobile. Fonctionnalités, offres et démonstration sont présentées sur le site du produit.",
			link: "Découvrir Questovery",
			secondaryLink: "Tous les produits",
		},
		faq: {
			title: "Avant de nous contacter",
			items: {
				budget: {
					question: "Combien coûte un projet ?",
					answer:
						"Le budget dépend de l’existant, des usages et du périmètre retenu. À titre indicatif, un logiciel métier qui aurait coûté autour de 100 000 € se réalise aujourd’hui pour environ 20 000 €, grâce au développement assisté par IA. Après un premier échange, la proposition précise ce qui sera livré, le calendrier et les modalités de suivi. Vous pouvez nous contacter sans budget défini.",
				},
				brief: {
					question: "Faut-il un cahier des charges pour commencer ?",
					answer:
						"Non. Décrivez votre fonctionnement actuel ou le blocage rencontré. Le cadrage sert justement à définir une première version limitée et ses critères de réussite.",
				},
				ai: {
					question: "L’IA ne risque-t-elle pas de dégrader la qualité ?",
					answer:
						"Pas lorsqu’elle est encadrée. L’IA produit une partie du code, mais un développeur expérimenté définit l’architecture, relit chaque modification et la valide par des tests. Vous recevez un code standard et documenté, qu’une autre équipe peut reprendre.",
				},
				after: {
					question: "Que se passe-t-il après la livraison ?",
					answer:
						"Selon votre choix, Lezo assure l’hébergement, la maintenance et les évolutions, ou votre équipe reprend la main grâce à la documentation livrée. Chaque volet est chiffré séparément.",
				},
				team: {
					question: "Faut-il une équipe technique de notre côté ?",
					answer:
						"Pas pour une application métier : un référent qui connaît le processus et peut mobiliser les utilisateurs suffit. Pour une migration Expo, un interlocuteur technique participe au diagnostic et à la transmission.",
				},
			},
		},
		cta: {
			title: "Quel problème souhaitez-vous résoudre ?",
			description:
				"Décrivez votre application ou la façon dont votre équipe travaille aujourd’hui. Nous vous répondons pour en discuter.",
			button: "Décrire mon besoin",
		},
	},
	businessApps: {
		hero: {
			label: "Applications métier",
			title: "Des outils métier adaptés à votre façon de travailler.",
			emphasis: "votre façon de travailler",
			intro:
				"Vous réalisez des visites, produisez des rapports ou assurez un suivi régulier de vos clients ? Lezo transforme un processus éparpillé entre fichiers, e-mails et outils en une seule application, environ 5 fois moins chère à développer qu’avant grâce à l’IA.",
			primaryCta: "Décrire mon processus",
			secondaryCta: "Voir le déroulement",
		},
		situations: {
			label: "Situations",
			title: "Vous reconnaissez-vous dans l’une de ces situations ?",
			description:
				"Ce sont des besoins fréquents dans les sociétés de services spécialisées. Au cadrage, nous vérifions ensemble s’ils justifient un outil sur mesure.",
			items: {
				reentry: {
					title: "Des informations saisies deux fois",
					description:
						"Les relevés, photos et observations sont pris sur le terrain, puis recopiés au bureau.",
				},
				reports: {
					title: "Des rapports longs à consolider",
					description:
						"Chaque rapport demande de rassembler des fichiers, de reprendre des tableaux et de vérifier les mêmes informations.",
				},
				tracking: {
					title: "Un suivi difficile à partager",
					description:
						"Dossiers, interventions et plans d’action vivent dans des tableurs et des boîtes e-mail ; personne n’a la vue d’ensemble.",
				},
				clients: {
					title: "Des clients qui demandent où en est leur dossier",
					description:
						"Vos clients veulent consulter leurs documents, suivre l’avancement ou transmettre des informations sans passer par l’e-mail.",
				},
			},
		},
		economics: {
			label: "Coût",
			title: "Un logiciel sur mesure n’est plus réservé aux gros budgets",
			description:
				"Hier, un outil métier sur mesure coûtait autour de 100 000 €, puis 20 000 à 30 000 € par an de maintenance et d’évolutions. Avec un développement assisté par IA et encadré, Lezo livre la même qualité pour environ 5 fois moins.",
		},
		saas: {
			label: "Abonnement ou logiciel",
			title: "Votre propre logiciel, pour le prix d’un abonnement",
			description:
				"Un abonnement SaaS se paie chaque mois, par utilisateur, aussi longtemps que vous l’utilisez. Avec des coûts de développement divisés par 5, un outil fait pour votre processus revient au même budget sur cinq ans, puis coûte moins cher chaque année.",
			subscription: {
				title: "Un abonnement SaaS",
				items: {
					fit: "Des fonctionnalités pensées pour le plus grand nombre, à contourner pour votre cas.",
					users: "Un prix par utilisateur qui augmente avec l’équipe.",
					forever: "Un coût qui ne s’arrête jamais.",
					roadmap: "Des données et des évolutions qui dépendent de l’éditeur.",
				},
			},
			custom: {
				title: "Votre logiciel",
				items: {
					fit: "Construit autour de votre processus réel.",
					users: "Un coût indépendant du nombre d’utilisateurs.",
					asset:
						"Un outil qui vous appartient, avec son code et sa documentation.",
					roadmap: "Des évolutions décidées selon vos priorités.",
				},
			},
			note: "Hypothèse indicative. Un logiciel du marché reste parfois la bonne réponse : le cadrage compare les deux options.",
		},
		solutions: {
			label: "Exemples de solutions",
			title: "Ce que nous pouvons construire",
			description:
				"Ce ne sont que des exemples. Votre solution part de votre processus réel ; parfois, adapter un outil existant suffit.",
			items: {
				collection: {
					title: "Collecte terrain sur mobile",
					description:
						"Formulaires, photos et relevés saisis sur place et disponibles au bureau sans ressaisie.",
				},
				documents: {
					title: "Production de documents",
					description:
						"Rapports, comptes rendus et synthèses générés à partir des données collectées, au format attendu par vos clients.",
				},
				tracking: {
					title: "Suivi des dossiers et des actions",
					description:
						"Attribution, échéances, statuts et historique partagés par toute l’équipe.",
				},
				portal: {
					title: "Portail client",
					description:
						"Un espace où vos clients consultent leurs documents, suivent l’avancement et vous transmettent des informations.",
				},
				integrations: {
					title: "Connexions avec vos outils",
					description:
						"Échanges de données avec vos logiciels existants : comptabilité, CRM, stockage de fichiers ou messagerie.",
				},
			},
		},
		usages: {
			label: "Deux usages",
			title: "Outiller votre équipe ou prolonger votre service",
			description:
				"Une entreprise peut avoir l’un, l’autre, ou les deux. Nous les distinguons dès le départ : leur intérêt ne se mesure pas de la même façon.",
			benefitLabel: "Bénéfice visé",
			checkLabel: "À vérifier au cadrage",
			items: {
				internal: {
					title: "Outiller les opérations internes",
					benefit:
						"Réduire les manipulations et faciliter la circulation de l’information.",
					check:
						"Processus, fréquence, temps perdu, utilisateurs et intégrations.",
				},
				clients: {
					title: "Prolonger une prestation auprès de vos clients",
					benefit:
						"Offrir à vos clients un suivi, un accès aux informations ou un nouveau service.",
					check:
						"Demande réelle des clients, adoption, exploitation et éventuel modèle commercial.",
				},
			},
		},
		process: {
			label: "Déroulement",
			title: "Du processus actuel à l’outil en service",
			description:
				"Une première version limitée, testée avec vos utilisateurs, puis des évolutions décidées avec votre référent métier.",
			steps: {
				understand: {
					title: "Comprendre votre processus",
					description:
						"Échanges avec les personnes concernées, examen des fichiers et outils utilisés, repérage des points de friction.",
				},
				compare: {
					title: "Comparer les solutions",
					description:
						"Outil standard, intégration, adaptation ou développement spécifique : nous recommandons l’option la plus adaptée, même quand ce n’est pas du sur-mesure.",
				},
				scope: {
					title: "Délimiter une première version",
					description:
						"Un usage prioritaire, des critères de réussite partagés et des maquettes pour valider le fonctionnement.",
				},
				build: {
					title: "Réaliser et tester",
					description:
						"Développement par étapes, démonstrations régulières et tests avec les futurs utilisateurs.",
				},
				deploy: {
					title: "Déployer",
					description:
						"Mise en service, reprise des données existantes si nécessaire et accompagnement des premiers utilisateurs.",
				},
				evolve: {
					title: "Suivre et faire évoluer",
					description:
						"Hébergement, maintenance et évolutions, selon ce que prévoit le contrat.",
				},
			},
		},
		deliverables: {
			label: "Livrables",
			title: "Ce que précise chaque proposition",
			items: {
				scope: "Un périmètre et des critères de réussite partagés.",
				mockups:
					"Des parcours ou maquettes permettant de valider le fonctionnement.",
				app: "Une application ou une intégration testée avec vos utilisateurs.",
				docs: "La documentation nécessaire à l’exploitation et à la reprise.",
				terms: "Les conditions d’accès, de livraison et de suivi.",
			},
		},
		after: {
			label: "Après la livraison",
			title: "Un logiciel métier vit après sa livraison",
			description:
				"Une fois en service, votre outil fait partie du quotidien de l’équipe. Dès la proposition, nous prévoyons comment il sera hébergé, maintenu et amélioré.",
			items: {
				hosting: {
					title: "Hébergement et exploitation",
					description:
						"Mise en ligne, sauvegardes et surveillance, dans l’environnement retenu ensemble.",
				},
				maintenance: {
					title: "Maintenance",
					description:
						"Corrections, mises à jour de sécurité et des dépendances, suivi du bon fonctionnement.",
				},
				evolutions: {
					title: "Évolutions",
					description:
						"Améliorations priorisées avec votre référent métier, à partir des retours des utilisateurs.",
				},
				handover: {
					title: "Documentation et reprise",
					description:
						"Choix et exploitation documentés, pour que l’outil puisse être repris si votre organisation change.",
				},
			},
		},
		budget: {
			label: "Budget",
			title: "Comment se construit le budget",
			description:
				"Le budget et le calendrier dépendent de l’existant, des usages et du périmètre retenu. À titre indicatif, comptez environ 20 000 € pour une première version et environ 5 000 € par an pour la faire vivre. La proposition distingue trois parts :",
			items: {
				initial: {
					title: "Réalisation initiale",
					description: "Cadrage, première version, tests et mise en service.",
				},
				running: {
					title: "Coûts de fonctionnement",
					description:
						"Hébergement, maintenance et services tiers éventuels, à prévoir dès le départ.",
				},
				evolutions: {
					title: "Évolutions",
					description:
						"Améliorations décidées au fil de l’usage, chiffrées séparément.",
				},
			},
			note: "Vous pouvez nous contacter sans budget défini : le premier échange aide aussi à situer l’investissement.",
		},
		reassurance:
			"Vous apportez la connaissance de votre métier. Lezo prend en charge les choix techniques et la réalisation, avec des points de validation définis ensemble.",
		fit: {
			label: "Pour bien démarrer",
			title: "Ce qui fait un bon projet",
			description:
				"Pas besoin d’équipe technique. Ces conditions aident à lancer une première version utile :",
			items: {
				process:
					"Un processus réel, que vous pouvez montrer et dont vous connaissez la fréquence.",
				referent: "Un référent métier disponible pour trancher.",
				users: "Des utilisateurs prêts à tester les parcours.",
				decision:
					"Un décideur qui porte le projet et anticipe la vie de l’outil après la livraison.",
			},
		},
		proof: {
			label: "Preuve",
			title: "Un produit web et mobile que nous exploitons",
			description:
				"Questovery associe un éditeur web, une application mobile et un suivi des expériences. Lezo l’a conçu, le développe et l’exploite au quotidien : la même exigence s’applique aux outils de nos clients.",
			link: "Lire l’étude de cas Questovery",
			note: "D’autres références seront publiées dès que les clients concernés l’auront accepté.",
		},
		faq: {
			title: "Vos questions sur les applications métier",
			items: {
				offTheShelf: {
					question: "Pourquoi ne pas utiliser un logiciel du marché ?",
					answer:
						"C’est parfois la bonne réponse. Le cadrage compare les solutions disponibles, l’intégration d’outils existants et le développement spécifique. Avec un développement assisté par IA, le sur-mesure coûte environ 5 fois moins qu’avant : sur quelques années, il revient souvent au prix d’un abonnement. Nous le recommandons lorsque votre processus le justifie.",
				},
				data: {
					question: "Que deviennent nos fichiers et données existants ?",
					answer:
						"Leur reprise est étudiée au cadrage : formats, volume, qualité et historique à conserver. La proposition précise ce qui est repris et comment.",
				},
				adoption: {
					question: "Comment s’assurer que l’équipe utilisera l’outil ?",
					answer:
						"Les utilisateurs participent dès le cadrage et testent les parcours avant la mise en service. La première version se concentre sur un usage, pour être adoptée avant d’être étendue.",
				},
				maintenance: {
					question: "Qui maintient l’application après la livraison ?",
					answer:
						"Lezo peut s’en charger : hébergement, maintenance et évolutions sont définis dans le contrat. La documentation livrée permet aussi à une autre équipe de reprendre l’application.",
				},
				budget: {
					question: "Comment le budget est-il établi ?",
					answer:
						"À partir du périmètre de la première version, des intégrations nécessaires et du niveau de suivi souhaité. La proposition distingue la réalisation, le fonctionnement et les évolutions.",
				},
			},
		},
		cta: {
			title: "Comment travaillez-vous aujourd’hui ?",
			description:
				"Où perdez-vous du temps ? Qui utilisera l’outil ? Quelques lignes suffisent pour préparer l’échange.",
			button: "Décrire mon processus",
		},
	},
	expoMigration: {
		hero: {
			label: "Migration React Native vers Expo",
			title: "Passez votre application React Native sur Expo.",
			emphasis: "sur Expo",
			intro:
				"Vos builds, vos montées de version ou vos publications mobilisent trop votre équipe ? Lezo migre votre application vers Expo et divise par 4 environ le coût de sa maintenance et de ses prochaines fonctionnalités.",
			primaryCta: "Faire le point sur mon application",
			secondaryCta: "Voir le déroulement",
		},
		situations: {
			label: "Situations",
			title: "Quand envisager une migration",
			items: {
				builds: {
					title: "Des builds fragiles",
					description:
						"Les builds iOS ou Android échouent de façon intermittente ou ne passent que sur un poste en particulier.",
				},
				release: {
					title: "Une publication complexe",
					description:
						"Signer, versionner et publier sur les stores demande des étapes manuelles mal documentées.",
				},
				native: {
					title: "Une maintenance native pesante",
					description:
						"Les dossiers ios/ et android/ accumulent des modifications que personne n’ose toucher, et chaque montée de React Native devient un chantier.",
				},
				departure: {
					title: "Le départ d’un développeur clé",
					description:
						"La connaissance du projet repose sur une personne qui s’en va, ou sur un prestataire que vous remplacez.",
				},
				adoption: {
					title: "La volonté d’adopter Expo",
					description:
						"Votre équipe veut profiter de l’outillage Expo : builds et soumissions EAS, mises à jour, configuration du natif par plugins.",
				},
				roadmap: {
					title: "Une évolution importante à venir",
					description:
						"Une refonte ou une fonctionnalité majeure est prévue, et vous voulez d’abord assainir la base.",
				},
			},
		},
		economics: {
			label: "Coût",
			title:
				"Une application Expo coûte environ 4 fois moins cher à faire évoluer",
			description:
				"Sur une application React Native ancienne, la maintenance représente souvent autour de 30 000 € par an, et une nouvelle fonctionnalité environ 10 000 €, entre builds à réparer et code natif à adapter. Une fois l’application sur Expo, ces coûts sont divisés par 4 environ.",
			reasonsTitle: "D’où vient l’économie",
			reasons: {
				native: {
					title: "Moins de natif à maintenir",
					description:
						"Les dossiers ios/ et android/ sont générés à partir de la configuration : plus de modifications manuelles à reporter à chaque mise à jour.",
				},
				upgrades: {
					title: "Des montées de version planifiées",
					description:
						"Le SDK Expo regroupe des versions compatibles entre elles : une montée de version redevient une tâche courante.",
				},
				builds: {
					title: "Des builds et publications automatisés",
					description:
						"EAS construit, signe et soumet l’application aux stores, sans dépendre d’un poste en particulier.",
				},
				ai: {
					title: "Une migration accélérée par l’IA",
					description:
						"L’IA prend en charge les adaptations répétitives ; chaque étape est validée par les builds et les parcours clés.",
				},
			},
		},
		process: {
			label: "Déroulement",
			title: "Quatre étapes, des résultats présentés à chaque fois",
			workLabel: "Travail réalisé",
			resultLabel: "Ce que vous obtenez",
			steps: {
				diagnostic: {
					title: "Diagnostic",
					work: "Examiner l’existant, les dépendances, les contraintes et les objectifs.",
					result: "Une décision claire : migrer ou non, et sur quel périmètre.",
				},
				plan: {
					title: "Plan de migration",
					work: "Définir les adaptations, l’ordre de réalisation et la validation.",
					result:
						"Un plan discuté avec votre équipe et une estimation propre au projet.",
				},
				build: {
					title: "Réalisation et validation",
					work: "Adapter le projet, puis vérifier les builds et les parcours clés.",
					result: "Une version livrée avec les résultats des vérifications.",
				},
				handover: {
					title: "Transmission",
					work: "Documenter les choix et passer la main à votre équipe.",
					result: "Une équipe autonome pour construire et publier.",
				},
			},
		},
		decisions: {
			label: "Après le diagnostic",
			title: "Ce qui est décidé ensemble",
			description:
				"Il n’existe pas de recette unique. Le diagnostic permet de trancher, avec votre équipe :",
			items: {
				tools: {
					title: "Les outils retenus",
					description:
						"Quels outils Expo adopter (prebuild, EAS Build, EAS Submit, mises à jour) et lesquels conserver parmi vos outils actuels.",
				},
				pace: {
					title: "Le rythme d’adoption",
					description:
						"Une adoption progressive, partie par partie, ou une bascule plus large en une fois.",
				},
				native: {
					title: "Les intégrations natives",
					description:
						"Pour chaque dépendance native : module Expo équivalent, config plugin existant, plugin à écrire ou code natif à conserver.",
				},
				delivery: {
					title: "La chaîne de publication",
					description:
						"Signature, environnements, profils de build et responsabilités de publication sur les stores.",
				},
			},
		},
		limits: {
			title: "Ce qu’une migration ne règle pas à elle seule",
			description:
				"Les bénéfices dépendent de votre projet. Une migration simplifie la configuration native et la chaîne de build ; elle ne corrige pas automatiquement la dette fonctionnelle, les performances ou l’architecture de l’application. Le diagnostic distingue clairement ce qui relève de la migration et ce qui n’en relève pas.",
		},
		deliverables: {
			label: "Livrables",
			title: "Ce que vous recevez",
			items: {
				diagnostic: "Un diagnostic écrit de l’existant et des dépendances.",
				plan: "Un plan d’intervention et l’ordre des adaptations.",
				code: "Les adaptations du code et de la configuration.",
				validation: "Les résultats de validation : builds et parcours testés.",
				docs: "Une documentation des choix et du nouveau fonctionnement.",
				session: "Une session de transmission avec votre équipe.",
			},
			note: "Les accès nécessaires, les responsabilités de publication, les délais, le suivi et les critères d’acceptation sont précisés dans la proposition.",
		},
		proof: {
			label: "Étude de cas",
			title: "Chouic : trois applications migrées vers Expo en un mois",
			description:
				"Chouic, studio de jeux mobiles joués par des millions de personnes, a confié à Lezo la migration de trois applications React Native. Son équipe a ensuite migré une quatrième application seule, et constate un gain de productivité et une baisse du coût de maintenance.",
			link: "Lire l’étude de cas Chouic",
			note: "Lezo développe aussi avec Expo sa propre application mobile, Questovery, qu’elle publie et maintient depuis sa création.",
		},
		faq: {
			title: "Vos questions sur la migration Expo",
			items: {
				rewrite: {
					question: "La migration implique-t-elle de réécrire l’application ?",
					answer:
						"Non, ce n’est pas l’objectif. L’essentiel du code applicatif est généralement conservé ; ce sont surtout la configuration native, certaines dépendances et la chaîne de build qui évoluent. Le diagnostic identifie les parties qui demandent une adaptation plus profonde.",
				},
				native: {
					question:
						"Comment sont traitées les dépendances et intégrations natives ?",
					answer:
						"Chaque dépendance est examinée : équivalent Expo, config plugin existant, plugin à écrire ou code natif conservé. Les choix sont documentés dans le plan et validés avec votre équipe.",
				},
				access: {
					question: "Quels accès sont nécessaires pour examiner le projet ?",
					answer:
						"Pour le diagnostic : un accès en lecture au dépôt de code et une description des environnements. Les accès aux comptes de publication et aux services tiers ne sont demandés que si la migration le nécessite, selon des règles fixées avec vous.",
				},
				handover: {
					question: "Comment prépare-t-on la reprise par notre équipe ?",
					answer:
						"Vos développeurs participent à la validation, la documentation décrit le nouveau fonctionnement et une session de transmission est prévue. L’objectif : que votre équipe construise et publie sans dépendre de Lezo.",
				},
				pricing: {
					question: "Comment le prix et le calendrier sont-ils établis ?",
					answer:
						"Après le diagnostic, à partir des dépendances natives à traiter, de la validation attendue et de la disponibilité de votre équipe. Le plan de migration s’accompagne d’une estimation propre au projet. Une fois l’application migrée, sa maintenance et ses nouvelles fonctionnalités coûtent en général environ 4 fois moins.",
				},
			},
		},
		cta: {
			title: "Où en est votre application ?",
			description:
				"Quelle application souhaitez-vous migrer ? Quel est votre principal blocage ? Ces deux réponses suffisent pour préparer un premier échange.",
			button: "Faire le point sur mon application",
		},
	},
	useCases: useCasesFr,
	work: {
		hero: {
			label: "Réalisations",
			title: "Ce que Lezo a construit et exploite",
			emphasis: "construit et exploite",
			intro:
				"Pour chaque projet : le besoin, la solution, ce que Lezo a fait exactement et comment le logiciel est utilisé.",
		},
		roleLabel: "Rôle de Lezo",
		scopeLabel: "Périmètre",
		items: {
			vaerdict: {
				badge: "Client · Logiciel métier",
				title: "Vaerdict",
				summary:
					"Un simulateur d’investissement immobilier pour les conseillers en gestion de patrimoine : études tous dispositifs, suivi annuel des investissements et base clients qui signale les rendez-vous à proposer.",
				role: "Développement de l’application, accompagnement au déploiement et à la commercialisation.",
				scope: "Moteur de calcul · Application web · Base clients et alertes",
				link: "Lire l’étude de cas",
				visualAlt: "Aperçu d’une simulation Vaerdict ajustée",
			},
			chouic: {
				badge: "Client · Migration Expo",
				title: "Chouic",
				summary:
					"Trois applications de jeux mobiles, jouées par des millions de joueurs, migrées de React Native vers Expo en un mois. L’équipe Chouic a ensuite migré une quatrième application seule.",
				role: "Diagnostic, migration et publication des trois applications, puis transmission de la méthode à l’équipe.",
				scope:
					"3 applications iOS et Android · Builds EAS · Méthode réutilisable",
				link: "Lire l’étude de cas",
				visualAlt: "Trois jeux mobiles passés de React Native à Expo",
			},
			questovery: {
				badge: "Produit édité par Lezo",
				title: "Questovery",
				summary:
					"Une plateforme web et mobile pour créer, proposer et suivre des jeux de piste et visites ludiques.",
				role: "Conception, développement, mise en production et exploitation.",
				scope: "Éditeur web · Application mobile · Suivi des expériences",
				link: "Lire l’étude de cas",
				visualAlt: "Aperçu de l’éditeur Questovery",
			},
		},
		policy: {
			title: "Notre règle de présentation",
			description:
				"Nous ne présentons que des projets où le rôle de Lezo est vérifiable et les résultats documentés. Les références clients sont publiées avec l’accord des entreprises concernées ; certains projets restent volontairement anonymes.",
		},
		upcoming: {
			title: "D’autres réalisations à venir",
			description:
				"De nouvelles études de cas seront ajoutées au fil des projets. Vous voulez savoir si nous avons déjà traité un besoin proche du vôtre ? Posez-nous la question.",
		},
		cta: {
			title: "Un projet en tête ?",
			description:
				"Présentez-nous votre situation : nous vous dirons franchement si Lezo est le bon partenaire.",
			button: "Parlons de votre projet",
		},
	},
	questoveryCase: {
		hero: {
			label: "Étude de cas · Produit édité par Lezo",
			title:
				"Questovery : une plateforme web et mobile conçue et exploitée par Lezo",
			emphasis: "conçue et exploitée",
			intro:
				"Comment Lezo a construit un produit complet, de l’éditeur web à l’application mobile et au suivi, et le fait évoluer avec ses utilisateurs.",
		},
		facts: {
			role: {
				label: "Rôle de Lezo",
				value: "Conception, développement, mise en production, édition",
			},
			platforms: {
				label: "Plateformes",
				value: "Web et mobile (iOS, Android)",
			},
			status: {
				label: "Statut",
				value: "En exploitation",
			},
		},
		situation: {
			title: "Situation",
			body: "Les professionnels qui accueillent du public (sites de visite, agences, organisateurs d’événements) veulent proposer des expériences ludiques sur mobile sans développer une application à chaque fois. Ils ont besoin de concevoir leurs scénarios, de les proposer à leurs visiteurs et d’en suivre l’usage.",
		},
		intervention: {
			title: "Intervention de Lezo",
			body: "Lezo a conçu et développé l’ensemble du produit, et en assure l’édition : choix techniques, réalisation, publication sur les stores, hébergement, maintenance et évolutions.",
		},
		solution: {
			title: "Solution",
			body: "Questovery associe trois briques :",
			items: {
				editor: {
					title: "Un éditeur web",
					description:
						"Pour concevoir les scénarios, les étapes et les contenus des expériences.",
				},
				mobile: {
					title: "Une application mobile",
					description: "Pour vivre l’expérience sur place, étape par étape.",
				},
				tracking: {
					title: "Un suivi des expériences",
					description:
						"Pour piloter les offres et voir comment elles sont utilisées.",
				},
			},
			shots: {
				editor: "Éditeur web Questovery",
				mobile: "Application mobile Questovery",
				tracking: "Suivi des expériences",
			},
		},
		usage: {
			title: "Usage",
			body: "Le Château Giscours utilise Questovery pour des visites proposées tout au long de l’année et pour des événements comme ses portes ouvertes. Des agences et des comités d’entreprise l’utilisent également ; à leur demande, ils ne sont pas nommés ici.",
			note: "Cette référence illustre l’usage du produit Questovery. Elle ne correspond pas à une prestation sur mesure réalisée par Lezo pour le Château Giscours.",
		},
		next: {
			title: "Suite",
			body: "Lezo continue d’améliorer Questovery à partir des retours de ses utilisateurs, y compris pour des applications à la marque de ses clients. Faire vivre notre propre produit guide la façon dont nous concevons et maintenons les applications de nos clients.",
		},
		productLink: "Découvrir Questovery",
		cta: {
			title: "Un projet web et mobile à construire ?",
			description:
				"Parlez-nous de votre besoin : application métier, portail client ou application mobile existante à moderniser.",
			button: "Parlons de votre projet",
		},
	},
	vaerdictCase: {
		hero: {
			label: "Étude de cas · Client",
			title:
				"Vaerdict : le simulateur immobilier des conseillers en patrimoine",
			emphasis: "simulateur immobilier",
			intro:
				"Lezo a développé l’ensemble de l’application, traduit les règles de la gestion de patrimoine en calculs et accompagné l’équipe de Vaerdict jusqu’au déploiement et à la commercialisation.",
		},
		facts: {
			role: {
				label: "Rôle de Lezo",
				value: "Développement, déploiement, appui à la commercialisation",
			},
			users: {
				label: "Utilisateurs",
				value:
					"Conseillers en gestion de patrimoine, réseaux bancaires, promoteurs",
			},
			status: {
				label: "Statut",
				value: "Commercialisé sur abonnement",
			},
		},
		productLink: "Découvrir Vaerdict",
		situation: {
			title: "Situation",
			body: "Les conseillers en gestion de patrimoine (CGP) accompagnent des clients qui investissent dans l’immobilier : neuf, ancien ou SCPI, avec des dispositifs fiscaux aux règles très différentes (LMNP, déficit foncier, Malraux, monument historique…). Pour conseiller, puis rassurer dans la durée, ils doivent montrer ce qu’un investissement rapporte réellement, loyers, fiscalité, crédit, charges et revente compris. Les fondateurs de Vaerdict, issus de ce métier, voulaient un outil qui fasse ce calcul avec rigueur et qui suive chaque investissement année après année.",
		},
		intervention: {
			title: "Intervention de Lezo",
			body: "Lezo a développé l’application dans son ensemble. Le travail a commencé par le métier : comprendre comment un CGP construit une étude, quelles règles s’appliquent à chaque dispositif, comment le financement et la revente pèsent sur le résultat. Ces logiques sont devenues un moteur de calcul, puis des écrans que les conseillers utilisent devant leurs clients. Lezo a ensuite accompagné les fondateurs et l’équipe de Vaerdict pour déployer la solution et la commercialiser.",
		},
		solution: {
			title: "Solution",
			body: "Vaerdict réunit dans une même application web :",
			items: {
				simulation: {
					title: "Des simulations tous dispositifs",
					description:
						"Neuf, ancien, SCPI : une étude complète de l’investissement, du financement à la revente.",
				},
				followUp: {
					title: "Un suivi dans la durée",
					description:
						"Chaque année, le conseiller ajuste les valeurs réelles et compare le résultat à l’étude de référence.",
				},
				opportunities: {
					title: "Une base clients qui crée des rendez-vous",
					description:
						"Des alertes signalent les clients à revoir et transforment le suivi en occasions de conseil.",
				},
				whiteLabel: {
					title: "Marque blanche et études en PDF",
					description:
						"Interfaces et documents aux couleurs du cabinet, comparaison de scénarios, études prêtes à remettre.",
				},
			},
		},
		engine: {
			title: "Traduire le métier en calcul",
			body: "Le cœur de Vaerdict est un moteur de calcul. Chaque étude suit la même chaîne, construite par Lezo à partir de la méthode des fondateurs :",
			steps: {
				revenue: {
					symbol: "A",
					title: "Recettes totales",
					detail: "Loyers, réduction d’impôt, TVA récupérée.",
				},
				expenses: {
					symbol: "B",
					title: "Dépenses totales",
					detail: "Charges, remboursement du financement, fiscalité.",
				},
				balance: {
					symbol: "C = A − B",
					title: "Bilan financier",
					detail:
						"L’épargne mobilisée, ou le revenu dégagé, sur toute la durée.",
				},
				capital: {
					symbol: "D",
					title: "Capital net constitué",
					detail:
						"Le prix de revente, moins le capital restant dû à la banque.",
				},
				performance: {
					symbol: "C + D",
					title: "Gain, TRI, rentabilité nette",
					detail:
						"Ce que l’investissement a réellement rapporté, comparable d’une étude à l’autre.",
				},
			},
			note: "Les règles fiscales des opérations de restauration immobilière (déficit foncier, monument historique, Malraux, Denormandie) ont été validées par le cabinet Rivière Avocats Associés.",
		},
		followUp: {
			label: "Le suivi annuel",
			title: "Rassurer avec des chiffres, pas avec des discours",
			body: "Une étude ne s’arrête pas à la signature. Chaque année, le conseiller met à jour les valeurs réelles (loyers, charges, taux, estimation du bien) et montre à son client où en est son investissement. Quand une estimation en baisse inquiète un client, la réponse est un calcul. Les alertes de la base clients indiquent qui revoir, et quand.",
		},
		shots: {
			simulation:
				"Simulation ajustée : étude de référence et résultat recalculé",
			followUp: "Base clients : alertes et rendez-vous à proposer",
		},
		rollout: {
			title: "Déploiement et commercialisation",
			body: "Lezo a accompagné les fondateurs et l’équipe de Vaerdict au-delà du développement : mise en production, déploiement auprès des conseillers et appui à la commercialisation de l’offre.",
		},
		today: {
			title: "Vaerdict aujourd’hui",
			body: "Vaerdict est commercialisé sur abonnement auprès des conseillers en gestion de patrimoine, des réseaux bancaires et des promoteurs, avec une option en marque blanche. L’application a été validée par un test d’intrusion, et Vaerdict bénéficie d’un prêt d’honneur de Bpifrance.",
			note: "Vaerdict est présenté avec l’accord de ses fondateurs. Les clients, biens et montants affichés dans les illustrations sont fictifs.",
		},
		cta: {
			title: "Un logiciel à construire autour de votre expertise ?",
			description:
				"Vous avez une méthode, des règles et des calculs que vous maîtrisez : parlons de l’outil qui les mettra entre les mains de vos équipes et de vos clients.",
			button: "Parlons de votre projet",
		},
	},
	chouicCase: {
		hero: {
			label: "Étude de cas · Migration React Native vers Expo",
			title: "Chouic : trois applications mobiles passées sur Expo en un mois",
			emphasis: "en un mois",
			intro:
				"Chouic édite des jeux mobiles à jouer en couple et entre amis, utilisés par des millions de joueurs. Lezo a migré trois de ses applications React Native vers Expo en un mois ; l’équipe Chouic a ensuite migré une quatrième application seule, avec la méthode et les outils transmis.",
		},
		siteLink: "Découvrir Chouic",
		facts: {
			client: {
				label: "Client",
				value: "Chouic, studio de jeux mobiles à Nantes",
			},
			scope: {
				label: "Mission",
				value: "3 applications iOS et Android migrées en 1 mois",
			},
			after: {
				label: "Ensuite",
				value: "Une 4e application migrée par l’équipe Chouic",
			},
		},
		client: {
			label: "Le client",
			title: "Un studio de jeux à partager en couple ou entre amis",
			body: "Chouic est un studio nantais qui crée des applications mobiles et des jeux de société. Ses applications (quiz de couple, action ou vérité, jeux de soirée) réunissent des millions de joueurs : Action ou Vérité dépasse à elle seule les 30 millions de téléchargements.",
			team: "Design, développement, écriture des questions et communication : tout est fait en interne, par une équipe qui fait vivre plusieurs applications en parallèle.",
			logoAlt: "Chouic",
			tagline: "Studio de jeux mobiles et de jeux de société · Nantes",
			portfolioLabel: "Quelques applications Chouic",
			portfolio: {
				lovbirdz: "LovBirdz",
				truthOrDare: "Action ou Vérité",
				spiky: "Spiky",
				koopla: "Koopla",
			},
		},
		challenge: {
			label: "Problématique",
			title: "Des applications anciennes qui accaparaient l’équipe",
			description:
				"Au fil des années, Chouic a constitué un parc d’applications React Native qu’il fallait continuer de maintenir. Chaque application avait sa propre configuration native, et chaque effort de maintenance se multipliait par le nombre d’applications.",
			items: {
				builds: {
					title: "Des builds fragiles",
					description:
						"Une mise à jour d’outil ou de dépendance suffisait à casser un build iOS ou Android, et la réparation passait avant le reste.",
				},
				upgrades: {
					title: "Des montées de version repoussées",
					description:
						"Monter de version React Native voulait dire reprendre le code natif de chaque application : un chantier sans cesse remis à plus tard.",
				},
				stores: {
					title: "Des publications laborieuses",
					description:
						"Signer, versionner et soumettre chaque application sur deux stores demandait des étapes manuelles, répétées pour tout le parc.",
				},
				roadmap: {
					title: "Moins de temps pour les jeux",
					description:
						"Le temps passé à maintenir l’existant manquait pour faire évoluer les jeux : nouveaux modes, nouvelles questions, nouvelles fonctionnalités.",
				},
			},
		},
		intervention: {
			label: "Intervention de Lezo",
			title: "Trois applications migrées en un mois, une par une",
			description:
				"Lezo a migré les applications l’une après l’autre, chacune publiée avant de passer à la suivante. Les joueurs ont simplement reçu une mise à jour de l’application qu’ils avaient déjà installée.",
			steps: {
				diagnostic: {
					title: "Un diagnostic par application",
					description:
						"Dépendances natives, configuration, signature et publication : pour chaque application, ce qui passe tel quel sur Expo et ce qui demande une adaptation.",
				},
				migration: {
					title: "Une migration validée app par app",
					description:
						"Configuration native en plugins, dépendances remplacées ou adaptées, builds et soumissions avec EAS. Chaque application est vérifiée sur ses parcours clés avant la suivante.",
				},
				handover: {
					title: "Une méthode transmise",
					description:
						"Les choix, les étapes et les outils de migration sont documentés et réutilisables : l’équipe Chouic les a appliqués seule à une quatrième application.",
				},
			},
		},
		results: {
			label: "Résultats",
			title: "Une maintenance allégée et du temps retrouvé pour les nouveautés",
			description:
				"Chouic constate un gain de productivité et une baisse du coût de maintenance de ses applications. Le temps libéré sert de nouveau à faire évoluer les jeux.",
			stats: {
				apps: { value: "3", label: "applications migrées par Lezo" },
				month: { value: "1 mois", label: "pour les trois migrations" },
				autonomy: {
					value: "+1",
					label: "application migrée ensuite par l’équipe Chouic, seule",
				},
			},
			points: {
				productivity: {
					title: "Un gain de productivité",
					description:
						"Builds et soumissions passent par EAS : moins d’étapes manuelles, plus de dépendance à un poste en particulier.",
				},
				maintenance: {
					title: "Un coût de maintenance en baisse",
					description:
						"Les dossiers natifs sont générés depuis la configuration, et les montées de version suivent le SDK Expo.",
				},
				features: {
					title: "De nouvelles fonctionnalités",
					description:
						"L’équipe consacre de nouveau son temps à faire évoluer ses jeux plutôt qu’à réparer leurs builds.",
				},
			},
		},
		next: {
			title: "Pourquoi cette mission a fonctionné",
			body: "Migrer plusieurs applications d’un même éditeur permet de mutualiser : la première migration pose la méthode, les suivantes la réutilisent. C’est ce qui a permis de tenir trois migrations en un mois, puis à l’équipe Chouic de mener la quatrième sans Lezo.",
		},
		scenes: {
			legacy: "React Native",
			expo: "Expo",
			phones: {
				couple: {
					game: "Quiz de couple",
					prompt: "Qui de vous deux cuisine le mieux ?",
					a: "Moi",
					b: "Toi",
				},
				dare: {
					game: "Action ou vérité",
					prompt: "Imite ton voisin de gauche pendant 30 secondes.",
					a: "Action",
					b: "Vérité",
				},
				friends: {
					game: "Quiz entre amis",
					prompt: "Qui ferait le meilleur agent secret ?",
					a: "Sam",
					b: "Inès",
				},
			},
			quiz: {
				game: "Quiz de couple",
				round: "Question 4 / 10",
				question: "Qui de vous deux oublie le plus souvent les anniversaires ?",
				players: { a: "Léa", b: "Hugo" },
				waiting: "Hugo réfléchit…",
				match: "Même réponse !",
				points: "+10 pts",
				score: "Complicité",
			},
			timeline: {
				title: "Déroulement de la mission",
				weeks: { a: "S1", b: "S2", c: "S3", d: "S4" },
				after: "Ensuite",
				apps: {
					a: "Application 1",
					b: "Application 2",
					c: "Application 3",
					d: "Application 4",
				},
				phases: {
					diagnostic: "Diagnostic",
					migration: "Migration",
					release: "Publication",
				},
				byLezo: "Migrée par Lezo",
				byClient: "Migrée par l’équipe Chouic",
				done: "Sur Expo",
				note: "Illustration du déroulement : la durée de chaque étape variait selon l’application.",
			},
			feed: {
				title: "Mises à jour publiées",
				build: "Build EAS",
				published: "Publiée",
				stores: "iOS · Android",
				items: {
					mode: "Nouveau mode de jeu",
					pack: "Pack de 200 questions",
					sdk: "Montée de version du SDK Expo",
					friends: "Défis entre amis",
				},
			},
		},
		cta: {
			title: "Vos applications React Native vous prennent trop de temps ?",
			description:
				"Présentez-nous vos applications : nous vous dirons lesquelles migrer en premier, en combien de temps, et ce que votre équipe pourra faire ensuite par elle-même.",
			button: "Faire le point sur mes applications",
		},
	},
	products: {
		hero: {
			label: "Produits",
			title: "Lezo édite aussi ses propres logiciels",
			emphasis: "ses propres logiciels",
			intro:
				"Les exploiter au quotidien influence directement la façon dont nous concevons et maintenons les applications de nos clients.",
		},
		questovery: {
			badge: "Disponible",
			title: "Questovery",
			tagline:
				"Créez et faites vivre vos jeux de piste, visites ludiques et expériences sur mobile.",
			description:
				"Une plateforme pour les professionnels qui souhaitent concevoir leurs scénarios, commercialiser leurs offres et piloter leurs expériences, éventuellement dans une application à leur marque.",
			features: {
				design: "Concevoir des scénarios",
				sell: "Commercialiser des offres",
				run: "Piloter les expériences",
				brand: "Une application à votre marque",
			},
			link: "Découvrir Questovery",
			caseLink: "Lire l’étude de cas",
			visualAlt: "Aperçu de l’application mobile Questovery",
		},
		why: {
			label: "Pourquoi éditer",
			title: "Ce que l’édition apporte à nos clients",
			items: {
				operations: {
					title: "L’exploitation au quotidien",
					description:
						"Nous vivons nous-mêmes la mise en production, la surveillance et le support d’un logiciel utilisé au quotidien.",
				},
				longevity: {
					title: "La durée",
					description:
						"Un produit se maintient sur des années : dépendances, montées de version, évolutions. C’est ce que nous anticipons dans vos projets.",
				},
				stores: {
					title: "La publication mobile",
					description:
						"Builds, signature et publication sur l’App Store et Google Play font partie de notre routine.",
				},
			},
		},
		whiteLabel: {
			title: "Une application de jeux de piste à votre marque ?",
			description:
				"Adaptation du moteur Questovery ou application en marque blanche : l’équipe Questovery s’en occupe directement.",
			link: "Voir les offres Questovery",
		},
		upcoming: {
			title: "D’autres produits en préparation",
			description: "Nous les présenterons ici dès qu’ils seront prêts.",
		},
	},
	about: {
		hero: {
			label: "À propos",
			title: "Lezo, développement et édition de logiciels.",
			emphasis: "édition",
			intro:
				"Lezo conçoit des applications web et mobiles sur mesure, modernise des applications existantes et développe ses propres produits, dont Questovery.",
		},
		activity: {
			label: "Activité",
			title: "Trois activités, une même exigence",
			items: {
				services: {
					title: "Prestations de développement",
					description:
						"Applications métier sur mesure, portails clients et migration d’applications React Native vers Expo.",
				},
				products: {
					title: "Édition de logiciels",
					description:
						"Des produits conçus, commercialisés et exploités par Lezo, à commencer par Questovery.",
				},
				support: {
					title: "Maintenance et évolutions",
					description:
						"Hébergement, corrections et nouvelles fonctionnalités des applications livrées.",
				},
			},
		},
		method: {
			label: "Méthode",
			title: "Comment nous travaillons avec vous",
		},
		principles: {
			label: "Engagements",
			title: "Nos principes de collaboration",
			items: {
				direct: {
					title: "Un interlocuteur direct",
					description:
						"Vous échangez avec la personne qui comprend votre besoin et réalise le projet.",
				},
				scope: {
					title: "Un périmètre explicite",
					description:
						"Chaque intervention précise ce qui est livré, ce qui ne l’est pas et ce qui se décidera plus tard.",
				},
				ai: {
					title: "Une IA encadrée",
					description:
						"L’IA nous permet de réaliser plus vite et moins cher, jamais sans relecture, tests et décision d’un développeur.",
				},
				checkpoints: {
					title: "Des points de validation",
					description:
						"Vous voyez l’avancement régulièrement et décidez aux étapes clés.",
				},
				docs: {
					title: "Une documentation utile",
					description:
						"Les choix et le fonctionnement sont documentés pour l’exploitation et la reprise.",
				},
				after: {
					title: "Des responsabilités claires après livraison",
					description:
						"Hébergement, maintenance et évolutions : qui fait quoi est défini dans la proposition.",
				},
			},
		},
		founder: {
			label: "Le fondateur",
			title: "Simon Boisset",
			description:
				"Lezo a été fondée par Simon Boisset, développeur logiciel et créateur de Questovery. Il dirige l’entreprise et travaille lui-même sur les projets, de l’analyse du besoin à la réalisation.",
			portraitAlt: "Portrait de Simon Boisset",
			link: "Voir le profil de Simon Boisset",
		},
		practical: {
			label: "Informations pratiques",
			title: "Travailler avec Lezo",
			items: {
				location: {
					label: "Localisation",
					value: "France",
				},
				collaboration: {
					label: "Collaboration",
					value:
						"À distance, avec des rencontres sur place lorsque le projet le demande",
				},
			},
			emailLabel: "E-mail",
		},
		staffing: {
			title: "Vous cherchez un développeur pour rejoindre votre équipe ?",
			description:
				"Lezo prend en charge des projets aux livrables définis. Pour un renfort au sein de votre équipe, consultez le profil de Simon Boisset.",
			link: "Voir le profil",
		},
		cta: {
			title: "Parlons de votre projet",
			description:
				"Décrivez votre situation et ce que vous souhaitez améliorer. Nous vous recontacterons pour définir la prochaine étape.",
			button: "Décrire mon besoin",
		},
	},
	contact: {
		hero: {
			label: "Contact",
			title: "Parlons de votre application ou de votre besoin métier.",
			emphasis: "votre besoin métier",
			intro:
				"Présentez votre situation actuelle et ce que vous souhaitez améliorer. Nous vous recontacterons pour préciser le besoin et la suite possible.",
		},
		form: {
			title: "Votre demande",
			requiredHint: "Les champs sans mention « facultatif » sont obligatoires.",
			optional: "facultatif",
			name: "Nom",
			email: "E-mail professionnel",
			company: "Entreprise",
			need: "Besoin",
			needPlaceholder: "Choisissez un besoin",
			needOptions: {
				businessApps: "Application métier",
				expoMigration: "Migration React Native vers Expo",
				other: "Autre besoin",
			},
			situation: "Situation et objectif",
			situationHints: {
				businessApps:
					"Comment travaillez-vous aujourd’hui ? Où perdez-vous du temps ? Qui utilisera l’outil ?",
				expoMigration:
					"Quelle application souhaitez-vous migrer ? Quel est votre principal blocage ?",
				other: "Décrivez votre situation actuelle et le résultat recherché.",
			},
			timeline: "Calendrier envisagé",
			timelinePlaceholder: "Ex. : mise en service avant l’été",
			budget: "Budget envisagé",
			budgetPlaceholder: "Une fourchette suffit, ou « à définir »",
			website: "Site ou lien public vers l’application",
			websitePlaceholder: "https://",
			honeypot: "Laissez ce champ vide",
			privacy:
				"Vos informations servent uniquement à répondre à votre demande et sont conservées au plus trois ans après votre dernier contact, pour un prospect sans contrat. Inutile d’envoyer ici des données internes ou des accès au code : nous en parlerons plus tard si besoin.",
			privacyLink: "Politique de confidentialité",
			submit: "Envoyer ma demande",
			submitting: "Envoi en cours…",
			errors: {
				summary: "Certains champs sont à corriger.",
				required: "Ce champ est obligatoire.",
				email: "Saisissez une adresse e-mail valide.",
				situation: "Ajoutez quelques précisions (20 caractères minimum).",
				url: "Saisissez une adresse commençant par http:// ou https://.",
			},
			success: {
				title: "Votre demande a bien été reçue.",
				description: "Nous vous recontacterons à l’adresse indiquée.",
				booking: {
					description:
						"Pour gagner du temps, choisissez dès maintenant un créneau pour en parler de vive voix.",
					button: "Réserver un créneau",
					fallback: "Sinon, nous vous recontacterons à l’adresse indiquée.",
				},
				again: "Envoyer une autre demande",
			},
			failure: {
				title: "L’envoi n’a pas abouti.",
				description:
					"Votre saisie n’est pas perdue. Vous pouvez réessayer ou nous écrire directement :",
			},
		},
		aside: {
			next: {
				title: "Après votre message",
				steps: {
					read: {
						title: "Nous lisons votre demande",
						description:
							"Pour vérifier qu’elle correspond à une offre de Lezo.",
					},
					call: {
						title: "Nous en parlons de vive voix",
						description:
							"Lors d’un échange que vous pouvez réserver dès l’envoi, pour préciser le besoin, les personnes impliquées et le calendrier.",
					},
					proposal: {
						title: "Nous définissons la suite ensemble",
						description:
							"Diagnostic, cadrage ou proposition : vous en connaissez le contenu et le coût éventuel avant de démarrer.",
					},
				},
			},
			direct: {
				title: "Vous préférez en parler directement ?",
				booking: "Réservez un échange dans notre agenda :",
				bookingLink: "Choisir un créneau",
				email: "Ou écrivez-nous :",
			},
			orientation: {
				title: "Une autre demande ?",
				staffing: {
					text: "Un développeur pour rejoindre votre équipe ?",
					link: "Profil de Simon Boisset",
				},
				product: {
					text: "Un jeu de piste ou une visite ludique sur mobile ?",
					link: "Découvrir Questovery",
				},
			},
		},
	},
	economics: {
		note: "Ordres de grandeur indicatifs : le chiffrage réel dépend de votre périmètre.",
		businessApp: {
			title: "Coût d’un logiciel métier",
			before: "Développement classique",
			after: "Avec Lezo",
			rows: {
				build: "Réalisation",
				yearly: "Maintenance et évolutions, par an",
			},
		},
		expo: {
			title: "Coût d’une application mobile",
			before: "React Native ancien",
			after: "Après migration Expo",
			rows: {
				yearly: "Maintenance, par an",
				feature: "Une nouvelle fonctionnalité",
			},
		},
		methodTitle: "Comment nous utilisons l’IA",
		method: {
			decide: {
				title: "L’IA écrit, un développeur décide",
				description:
					"Architecture, choix techniques et validation de chaque modification restent entre les mains d’un développeur expérimenté.",
			},
			verify: {
				title: "Chaque changement est vérifié",
				description:
					"Revue de code, tests automatisés et démonstrations régulières : l’IA accélère la réalisation, sans raccourci sur la qualité.",
			},
			own: {
				title: "Un code standard qui vous appartient",
				description:
					"Technologies répandues, code lisible et documenté : une autre équipe peut le reprendre à tout moment.",
			},
		},
		saas: {
			title: "Coût cumulé sur six ans",
			subscription: {
				name: "Abonnement SaaS",
				detail: "{users} utilisateurs à {price} par mois",
			},
			custom: {
				name: "Votre logiciel avec Lezo",
				detail: "{build} de réalisation, puis {yearly} par an",
			},
			crossing: "Même budget à {years} ans",
			summary:
				"Après {years} ans, un abonnement SaaS et votre logiciel ont coûté environ {total} chacun. Ensuite, l’abonnement coûte {saas} par an, votre logiciel {custom}.",
		},
	},
	scenes: {
		host: "app.votre-entreprise.fr",
		aiFlow: {
			file: "rapports/export.ts",
			stages: {
				generate: "IA",
				review: "Revue",
				tests: "Tests",
				live: "En ligne",
			},
			request: "Export PDF des rapports",
			aiChip: "Proposé par l’IA",
			reviewChip: "En revue",
			reviewer: "DEV",
			comment: "Prévoir les rapports sans photo.",
			code: {
				a: "export async function exportReport(id) {",
				b: "  const report = await reports.get(id);",
				c: "  const pdf = await renderPdf(report);",
				d: "  return files.save(pdf);",
				e: "}",
			},
			fix: "  report.photos ??= [];",
			checksTitle: "Vérifications",
			checks: {
				unit: { label: "Tests automatisés", value: "48/48" },
				journey: { label: "Parcours terrain → rapport", value: "OK" },
				builds: { label: "Builds web, iOS et Android", value: "OK" },
			},
			live: {
				title: "Mise en ligne",
				version: "Version 1.4 en production",
				detail: "L’export PDF est disponible pour toute l’équipe.",
				signoff: "Relu, testé et validé par un développeur",
			},
		},
		assemble: {
			appName: "Suivi des interventions",
			status: "Tout au même endroit",
			sources: {
				email: "E-mail",
				sheet: "Tableur",
				photo: "Photo",
				note: "Post-it",
				pdf: "PDF",
			},
			modules: {
				request: "Demande client",
				planning: "Planning",
				survey: "Relevé terrain",
				actions: "Actions",
				report: "Rapport",
			},
			request: {
				subject: "Visite annuelle, résidence Les Tilleuls",
				from: "Claire Martin",
				time: "09:12",
			},
			planning: {
				a: { who: "Équipe A", when: "Lun. 14" },
				b: { who: "Équipe B", when: "Mar. 15" },
				c: { who: "Équipe A", when: "Jeu. 17" },
			},
			survey: {
				label: "Chaufferie, bâtiment B",
				meta: "4 photos · 12 mesures",
			},
			actions: {
				a: "Remplacer le joint de vanne",
				b: "Planifier le contrôle",
				c: "Envoyer le rapport",
			},
			report: { title: "Rapport de visite", status: "Généré" },
		},
		field: {
			formTitle: "Relevé · Chaufferie B",
			pressure: "Pression",
			pressureValue: "1,8 bar",
			state: "État général",
			stateValue: "Conforme",
			photos: "Photos",
			send: "Envoyer le relevé",
			sent: "Relevé envoyé",
			dashTitle: "Interventions",
			sync: "Synchronisé",
			rows: {
				a: { site: "Résidence Les Tilleuls", status: "Rapport prêt" },
				b: { site: "Groupe scolaire Jaurès", status: "Planifiée" },
				c: { site: "Mairie annexe", status: "En cours" },
			},
		},
		pipeline: {
			file: "app.config.ts",
			stages: {
				diagnostic: "Diagnostic",
				plan: "Plan",
				build: "Builds",
				handover: "Transmission",
			},
			deps: {
				title: "Dépendances natives",
				a: { name: "react-native-camera", verdict: "Module Expo" },
				b: { name: "react-native-firebase", verdict: "Config plugin" },
				c: { name: "sdk-paiement-interne", verdict: "Plugin à écrire" },
				d: { name: "module-bluetooth", verdict: "Natif conservé" },
			},
			plan: {
				title: "Plan de migration",
				a: "Configuration native en plugins",
				b: "Dépendances, une par une",
				c: "Profils de build et signature",
				d: "Publication sur les stores",
			},
			build: {
				title: "Builds et validation",
				ios: "Build iOS",
				android: "Build Android",
				submit: "Soumission aux stores",
				flows: "Parcours clés testés",
			},
			handover: {
				title: "Transmission",
				doc: "Nouveau fonctionnement documenté",
				session: "Session avec votre équipe",
				owner: "Votre équipe construit et publie",
			},
		},
		quest: {
			title: "Le secret du domaine",
			step: "Étape 3 / 8",
			place: "L’orangerie",
			approach: "Vous approchez",
			distance: "40 m",
			question: "Combien de colonnes soutiennent la façade ?",
			answers: { a: "4", b: "6", c: "8" },
			validated: "Étape validée",
			points: "+120 pts",
			ranking: "Classement",
			teams: { a: "Les Renards", b: "Équipe Orange", c: "Les Curieux" },
		},
		editor: {
			steps: {
				a: "Accueil",
				b: "La cour d’honneur",
				c: "L’orangerie",
				d: "Le chai",
			},
			stepType: "Énigme",
			trigger: "Déclenchement GPS",
			radius: "Rayon 30 m",
			publish: "Publier",
		},
		tracking: {
			title: "Parties en cours",
			live: "En direct",
			done: "Terminée",
			running: "En cours",
		},
		blueprint: {
			notes: {
				a: "« On ressaisit tout le soir »",
				b: "« Le client relance par e-mail »",
				c: "3 outils, 2 tableurs",
			},
			flow: { a: "Visite", b: "Relevé", c: "Rapport", d: "Envoi" },
			scope: "V1 · un usage prioritaire",
			demo: "Démo validée",
			live: "v1.0 en service",
			docs: "Documentation",
			next: "Évolutions",
		},
		vaerdict: {
			nav: {
				contacts: "Base contacts",
				files: "Dossiers",
				simulation: "Simulation",
				alerts: "Alertes",
			},
			client: "M. et Mme Durand",
			project: "T2 · LMNP · crédit sur 20 ans",
			pdf: "Générer le PDF",
			field: "Prix de revente estimé",
			fieldBefore: "160 000 €",
			fieldAfter: "146 000 €",
			reference: "Référence",
			adjusted: "Ajusté",
			horizon: "22 ans",
			rows: {
				balance: "Bilan financier",
				resale: "Prix de revente",
				capital: "Capital net constitué",
				gain: "Gain",
				irr: "TRI",
			},
			values: {
				reference: {
					balance: "−67 500 €",
					resale: "160 000 €",
					capital: "159 300 €",
					gain: "+91 800 €",
					irr: "7,4 %",
				},
				adjusted: {
					balance: "−67 500 €",
					resale: "146 000 €",
					capital: "145 300 €",
					gain: "+77 800 €",
					irr: "6,6 %",
				},
			},
			verdict: "Même revendu moins cher, l’investissement reste gagnant.",
			followUp: {
				title: "Mes alertes",
				subtitle: "Suivi annuel du portefeuille",
				count: "3 opportunités",
				upToDate: "À jour",
				booked: "Rendez-vous proposé",
				clients: {
					a: {
						initials: "D",
						name: "M. et Mme Durand",
						project: "T2 · LMNP",
						alert: "Bilan annuel à présenter",
					},
					b: {
						initials: "L",
						name: "Mme Lefèvre",
						project: "Résidence · Pinel",
						alert: "Fin de l’avantage fiscal dans 6 mois",
					},
					c: {
						initials: "G",
						name: "M. Garnier",
						project: "Immeuble · déficit foncier",
						alert: "Crédit à renégocier",
					},
				},
			},
		},
	},
	blog: {
		heroLabel: "Blog",
		heroTitle: "Articles",
		description: "Notes, guides et actualités.",
		featured: "Dernier article",
		latest: "Autres articles",
		empty: "Aucun article pour le moment.",
		back: "Retour au blog",
		other: "Autres articles",
		errorTitleList: "Impossible de charger les articles",
		errorTitleDetail: "Impossible de charger cet article",
		errorFallback: "Merci de réessayer plus tard.",
	},
	docs: {
		heroLabel: "Documents",
		heroTitle: "Documents publics",
		heroDescription:
			"Mentions légales, politique de confidentialité et autres documents publics.",
		empty: "Aucun document pour le moment.",
		effectiveDate: "Dernière mise à jour",
		cardDescriptions: {
			legal: "Informations sur l’éditeur et l’hébergeur.",
			privacy: "Traitement des données personnelles sur ce site.",
		},
	},
	consent: {
		title: "Cookies et mesure d’audience",
		description:
			"Avec votre accord, PostHog mesure les pages consultées, les sources de visite, les clics de contact et les envois du formulaire pour améliorer le site.",
		essentialTitle: "Essentiels",
		essentialDescription:
			"Nécessaires au fonctionnement du site, comme la mémorisation de la langue.",
		analyticsTitle: "Mesure d’audience",
		analyticsDescription:
			"Mesure d’audience facultative avec PostHog, hébergé dans l’UE. Vous pouvez refuser ou retirer votre accord dans les préférences cookies. Votre choix est valable six mois.",
		policyLink: "Lire la politique de confidentialité",
		showDetails: "Détails",
		hideDetails: "Masquer les détails",
		close: "Fermer",
		deny: "Refuser",
		accept: "Accepter",
	},
	footer: {
		description:
			"Lezo développe et maintient des applications web et mobiles, et édite ses propres produits logiciels.",
		servicesTitle: "Services",
		companyTitle: "Lezo",
		infoTitle: "Informations",
		contact: "Contact",
		docs: "Documents",
		legal: "Mentions légales",
		privacy: "Confidentialité",
		cookies: "Préférences cookies",
		rights: "Tous droits réservés.",
	},
	notFound: {
		label: "Erreur",
		title: "Page introuvable",
		description: "La page demandée n’existe pas ou a été déplacée.",
		backHome: "Retour à l’accueil",
	},
};
